import { render, staticRenderFns } from "./WeightDetail.vue?vue&type=template&id=110bb5ef"
import script from "./WeightDetail.vue?vue&type=script&lang=js"
export * from "./WeightDetail.vue?vue&type=script&lang=js"
import style0 from "./WeightDetail.vue?vue&type=style&index=0&id=110bb5ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports